// client/src/lib/utils/date-utils.ts
/**
 * UTILIDADES DE FECHA SIMPLIFICADAS - SOLUCIÓN DEFINITIVA
 * El backend ahora trabaja en hora Cuba, no hay conversiones UTC
 */

/**
 * Obtiene el INICIO del día (00:00:00) en hora Cuba
 */
export function getStartOfDay(date?: Date): Date {
  const localDate = date ? new Date(date) : new Date();
  
  // Crear fecha a las 00:00:00 hora Cuba
  const startOfDay = new Date(
    localDate.getFullYear(),
    localDate.getMonth(),
    localDate.getDate(),
    0, 0, 0, 0
  );
  
  console.log('🌅 [DateUtils] Inicio del día Cuba:', {
    fecha: startOfDay.toLocaleString('es-CU'),
    ISO: startOfDay.toISOString()
  });
  
  return startOfDay;
}

/**
 * Obtiene el FIN del día (23:59:59.999) en hora Cuba
 */
export function getEndOfDay(date?: Date): Date {
  const localDate = date ? new Date(date) : new Date();
  
  // Crear fecha a las 23:59:59.999 hora Cuba
  const endOfDay = new Date(
    localDate.getFullYear(),
    localDate.getMonth(),
    localDate.getDate(),
    23, 59, 59, 999
  );
  
  console.log('🌇 [DateUtils] Fin del día Cuba:', {
    fecha: endOfDay.toLocaleString('es-CU'),
    ISO: endOfDay.toISOString()
  });
  
  return endOfDay;
}

/**
 * Obtiene el rango COMPLETO de "hoy" en hora Cuba
 */
export function getTodayRange(): { start: Date; end: Date } {
  const start = getStartOfDay();
  const end = getEndOfDay();
  
  console.log('✅ [DateUtils] Rango HOY Cuba:', {
    inicio: start.toLocaleString('es-CU'),
    fin: end.toLocaleString('es-CU'),
    '00:00 - 23:59': 'Incluye todas las ventas del día en hora Cuba'
  });
  
  return { start, end };
}

/**
 * Obtiene inicio de semana (lunes) en hora Cuba
 */
export function getStartOfWeek(date?: Date): Date {
  const localDate = date ? new Date(date) : new Date();
  const dayOfWeek = localDate.getDay(); // 0 = domingo, 1 = lunes...
  
  // Calcular días hasta el lunes más reciente
  const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(localDate);
  monday.setDate(localDate.getDate() - daysToMonday);
  
  return getStartOfDay(monday);
}

/**
 * Obtiene fin de semana (domingo) en hora Cuba
 */
export function getEndOfWeek(date?: Date): Date {
  const localDate = date ? new Date(date) : new Date();
  const dayOfWeek = localDate.getDay();
  
  // Calcular días hasta el domingo
  const daysToSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
  const sunday = new Date(localDate);
  sunday.setDate(localDate.getDate() + daysToSunday);
  
  return getEndOfDay(sunday);
}

/**
 * Obtiene inicio del mes en hora Cuba
 */
export function getStartOfMonth(date?: Date): Date {
  const localDate = date ? new Date(date) : new Date();
  const firstDay = new Date(localDate.getFullYear(), localDate.getMonth(), 1);
  
  return getStartOfDay(firstDay);
}

/**
 * Obtiene fin del mes en hora Cuba
 */
export function getEndOfMonth(date?: Date): Date {
  const localDate = date ? new Date(date) : new Date();
  const lastDay = new Date(localDate.getFullYear(), localDate.getMonth() + 1, 0);
  
  return getEndOfDay(lastDay);
}

/**
 * Formatea fecha para mostrar al usuario
 */
export function formatLocalDate(date: Date | string, includeTime: boolean = true): string {
  const localDate = typeof date === 'string' ? new Date(date) : date;
  
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Havana',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };
  
  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
    options.second = '2-digit';
  }
  
  return localDate.toLocaleString('es-CU', options);
}

/**
 * Convierte string YYYY-MM-DD a rango en hora Cuba
 */
export function dateStringToRange(dateString: string): { start: Date; end: Date } {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  
  return {
    start: getStartOfDay(date),
    end: getEndOfDay(date)
  };
}

/**
 * Diagnóstico del sistema
 */
export function diagnoseSystem(): void {
  const now = new Date();
  console.log('🔍 DIAGNÓSTICO SISTEMA:', {
    'Hora actual sistema': now.toString(),
    'Hora Cuba': now.toLocaleString('es-CU'),
    'Zona horaria': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'Configuración': 'Backend en hora Cuba, sin conversiones UTC'
  });
}